// Generated automatically by nearley
// http://github.com/Hardmath123/nearley
(function () {
function id(x) {return x[0]; }

var lexer = require('./date-lexer');
var utils = require('./date-utils');
var grammar = {
    Lexer: lexer,
    ParserRules: [
    {"name": "main", "symbols": ["comparator", "_", "datetime"], "postprocess": utils.merge},
    {"name": "main$ebnf$1", "symbols": ["_"], "postprocess": id},
    {"name": "main$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "main$ebnf$2", "symbols": ["_"], "postprocess": id},
    {"name": "main$ebnf$2", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "main", "symbols": ["datetime", "main$ebnf$1", (lexer.has("range") ? {type: "range"} : range), "main$ebnf$2", "datetime"], "postprocess": utils.merge},
    {"name": "main$ebnf$3", "symbols": ["_"], "postprocess": id},
    {"name": "main$ebnf$3", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "main$ebnf$4", "symbols": ["_"], "postprocess": id},
    {"name": "main$ebnf$4", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "main", "symbols": ["datetime", "main$ebnf$3", (lexer.has("range") ? {type: "range"} : range), "main$ebnf$4", "time"], "postprocess": utils.mergeDate},
    {"name": "main", "symbols": ["datetime"], "postprocess": utils.merge},
    {"name": "datetime", "symbols": ["date_exp"]},
    {"name": "datetime$ebnf$1", "symbols": ["_"], "postprocess": id},
    {"name": "datetime$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "datetime$ebnf$2", "symbols": ["at"], "postprocess": id},
    {"name": "datetime$ebnf$2", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "datetime", "symbols": ["date_exp", "datetime$ebnf$1", "datetime$ebnf$2", "_", "time"]},
    {"name": "date_exp", "symbols": ["year"]},
    {"name": "date_exp", "symbols": ["month_name", "_", "year"]},
    {"name": "date_exp$ebnf$1", "symbols": ["day"], "postprocess": id},
    {"name": "date_exp$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "date_exp$ebnf$2", "symbols": ["ordinal"], "postprocess": id},
    {"name": "date_exp$ebnf$2", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "date_exp$ebnf$3", "symbols": ["comma"], "postprocess": id},
    {"name": "date_exp$ebnf$3", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "date_exp", "symbols": ["date_exp$ebnf$1", "month_name", "_", "date", "date_exp$ebnf$2", "date_exp$ebnf$3", "_", "year"]},
    {"name": "date_exp", "symbols": ["month", "x", "date", "x", "year"]},
    {"name": "date_exp", "symbols": ["month", "x", "date", "x", "year_short"]},
    {"name": "date_exp", "symbols": ["month", "x", "year"]},
    {"name": "date_exp", "symbols": ["month", "x", "year_short"]},
    {"name": "time", "symbols": ["hour", "s", "meridian"]},
    {"name": "time", "symbols": ["hour", "st", "minute", "s", "meridian"]},
    {"name": "time", "symbols": ["hour", "st", "minute", "st", "second", "s", "meridian"]},
    {"name": "day", "symbols": ["day_name", "_"]},
    {"name": "comparator", "symbols": [(lexer.has("comparator") ? {type: "comparator"} : comparator)], "postprocess": utils.formatByType('comparator')},
    {"name": "year", "symbols": [(lexer.has("year") ? {type: "year"} : year)], "postprocess": utils.formatByType('year')},
    {"name": "year_short", "symbols": [(lexer.has("digit_2") ? {type: "digit_2"} : digit_2)], "postprocess": utils.formatByType('year_short')},
    {"name": "month", "symbols": [(lexer.has("digit_2") ? {type: "digit_2"} : digit_2)], "postprocess": utils.formatByType('month')},
    {"name": "month_name", "symbols": [(lexer.has("month_name") ? {type: "month_name"} : month_name)], "postprocess": utils.formatByType('month_name')},
    {"name": "date", "symbols": [(lexer.has("digit_2") ? {type: "digit_2"} : digit_2)], "postprocess": utils.formatByType('date')},
    {"name": "day_name", "symbols": [(lexer.has("day_name") ? {type: "day_name"} : day_name)], "postprocess": utils.nil},
    {"name": "ordinal", "symbols": [(lexer.has("ordinal") ? {type: "ordinal"} : ordinal)], "postprocess": utils.nil},
    {"name": "hour", "symbols": [(lexer.has("digit_2") ? {type: "digit_2"} : digit_2)], "postprocess": utils.formatByType('hour')},
    {"name": "minute", "symbols": [(lexer.has("digit_2") ? {type: "digit_2"} : digit_2)], "postprocess": utils.formatByType('minute')},
    {"name": "second", "symbols": [(lexer.has("digit_2") ? {type: "digit_2"} : digit_2)], "postprocess": utils.formatByType('second')},
    {"name": "meridian$ebnf$1", "symbols": []},
    {"name": "meridian$ebnf$1", "symbols": ["meridian$ebnf$1", (lexer.has("meridian") ? {type: "meridian"} : meridian)], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "meridian", "symbols": ["meridian$ebnf$1"], "postprocess": id},
    {"name": "comma", "symbols": [(lexer.has("comma") ? {type: "comma"} : comma)], "postprocess": utils.nil},
    {"name": "at", "symbols": [(lexer.has("at") ? {type: "at"} : at)], "postprocess": utils.nil},
    {"name": "sw", "symbols": [{"literal":" "}], "postprocess": utils.nil},
    {"name": "x", "symbols": [(lexer.has("x") ? {type: "x"} : x)], "postprocess": utils.nil},
    {"name": "s$ebnf$1", "symbols": []},
    {"name": "s$ebnf$1", "symbols": ["s$ebnf$1", {"literal":" "}], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "s", "symbols": ["s$ebnf$1"], "postprocess": utils.nil},
    {"name": "_", "symbols": [(lexer.has("wschar") ? {type: "wschar"} : wschar)], "postprocess": utils.nil},
    {"name": "st", "symbols": [(lexer.has("st") ? {type: "st"} : st)], "postprocess": utils.nil}
]
  , ParserStart: "main"
}
if (typeof module !== 'undefined'&& typeof module.exports !== 'undefined') {
   module.exports = grammar;
} else {
   window.Grammar = grammar;
}
})();



//////////////////
// WEBPACK FOOTER
// ./project/services/date-parser/date-parser.ne
// module id = 808
// module chunks = 3